import { useContext } from "react";
import { ACPSupportRequestsContext } from "../../../context";
import { Button } from "@mui/material";

const ClearHistoryButton = () => {
    const { setSearchHistory } = useContext(ACPSupportRequestsContext);
    return (<Button fullWidth variant="contained" color="turquoise" sx={{ display: "block" }} onMouseDown={(e) => e.preventDefault()} onClick={() => setSearchHistory([])}>Clear History</Button>)
}

export default ClearHistoryButton;